<template>
  <Settings />
</template>

<script lang="ts">
import Vue from 'vue';
import Settings from '../components/Settings.vue';

export default Vue.extend({
    components: {
        Settings,
    },
});
</script>
